import { SETTINGS } from "./settings";
let config = SETTINGS;

export const initialize = (newConfig) => {
  config = { ...config, ...newConfig };
};

export const getConfig = () => config;
